import { useState } from "react";

import { EMPTY_PINTEREST_FORM } from "../DestinationCreation.constants";

/**
 * Pinterest Tag / CAPI: OAuth + pixel selection via
 * `PinterestAuthAndSelectPixels`, or the manual account / token / tag fields.
 */
const usePinterestDestination = ({
    setSaveDisabled,
    setPixelIdError,
    setAccessTokenError,
}) => {
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [isAuthButtonVisible, setIsAuthButtonVisible] = useState(true);
    const [capiData, setCapiData] = useState(null);
    const [, setFormStatus] = useState(false);
    const [formData, setFormData] = useState(EMPTY_PINTEREST_FORM);

    const resetFormData = () => setFormData(EMPTY_PINTEREST_FORM);

    const resetOnTypeChange = () => {
        setIsAuthorised(false);
        setFormStatus(true);
        setIsAuthButtonVisible(true);
        resetFormData();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        const newForm = {
            ...formData,
            [name]: value,
        };
        setFormData(() => newForm);
        if (
            newForm?.accountId &&
            newForm?.accessToken &&
            newForm?.pinterestTagId
        )
            setSaveDisabled(false);
        if (name === "accountId") {
            setPixelIdError("");
        } else if (name === "accessToken") {
            setAccessTokenError("");
        }
    };

    return {
        isAuthorised,
        setIsAuthorised,
        isAuthButtonVisible,
        setIsAuthButtonVisible,
        capiData,
        setCapiData,
        setFormStatus,
        formData,
        resetFormData,
        resetOnTypeChange,
        handleInputChange,
    };
};

export default usePinterestDestination;
